const regex = /<\/?[a-z][\s\S]*>/i;

export const checkIsHtml = (str) => regex.test(str);
